import { colors, screen } from 'components/styles/variables';
import Navbar from 'components/Navbar';
import { ReactNode, useContext } from 'react';
import { useRouter } from 'next/router';

import DirectToVdpContext from 'contexts/DirectToVdpContext';
import LeaderboardAds from 'components/Ad/LeaderboardAds';
import {
  handleDirectToVdpNavigation,
  handleSrpNavigation,
  getHighlightedNavbarItem,
} from './utils';
import { AutolistLogo } from './AutolistLogo';
import { BackToSearch } from './BackToSearch';

export interface HeaderProps {
  url?: string;
  subNav?: ReactNode;
  includeAds?: boolean;
  isVdp?: boolean;
  showOnScroll?: boolean;
  vdpUrl?: string;
}

function Header({
  url,
  subNav,
  includeAds = true,
  isVdp = false,
  showOnScroll = false,
  vdpUrl,
}: HeaderProps): JSX.Element {
  const router = useRouter();
  let { back } = router;
  const { isDirectToVdp } = useContext(DirectToVdpContext);

  back = (): void => {
    if (isDirectToVdp && vdpUrl) {
      handleDirectToVdpNavigation(router, vdpUrl);
    } else {
      handleSrpNavigation(router);
    }
  };

  return (
    <header data-testid="header-element">
      {includeAds && <LeaderboardAds />}
      <div className="al-container">
        {isVdp ? <BackToSearch onClick={back} showEnhancement={isDirectToVdp} /> : <AutolistLogo />}
        <Navbar currentItem={getHighlightedNavbarItem(url)} />
      </div>
      {subNav}
      <style jsx>{`
        header {
          position: relative;
          z-index: 600;
          border-bottom: 1px solid ${colors.G1};
          background-color: white;
        }

        .al-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 63px;
          margin-right: auto;
          margin-left: auto;
          padding-left: 15px;
          padding-right: 15px;
        }

        @media (min-width: ${screen.smMin}) {
          .al-container {
            width: 750px;
          }
        }

        @media (min-width: ${screen.mdMin}) {
          .al-container {
            width: 970px;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .al-container {
            width: 100%;
            padding-left: 24px;
            padding-right: 24px;
          }
        }

        @media (max-width: ${screen.smMin}) {
          header {
            position: ${showOnScroll ? 'fixed' : 'relative'};
            width: 100%;
          }
        }
      `}</style>
    </header>
  );
}

export default Header;
